import React, { useEffect, useState } from 'react';
import { useRouteMatch } from "react-router-dom";
//ACTIONS AND CONTEXT
import { useMainContext } from "../../../contexts/MainContext";
//COMPONENTS

//ASSETS

const MenuDemandImporter = ({ linkActive, name }) => {
    let mainContext = useMainContext();
    let { path } = useRouteMatch();

    const [pageName, setPageName] = useState(name);

    useEffect(() => {
        mainContext.setIsDirty(false);
    }, []);

    useEffect(() => {

    }, []);

    const requestNavigation = (goTo) => {
        let goToArr = goTo.split("/");
        let pathArr = path.split("/");
        if (goToArr[goToArr.length - 1] == pathArr[pathArr.length - 1])
            return;

        window.location.href = goTo;
    }

    //Menu
    const getCSSClass = (link) => {
        let _className = "";
        if (linkActive == link)
            _className += "active-tab ";
        //_className = "btn btn-white mr-3 btn-submenu ";

        return _className;
    }

    return (
        <>
            <div className="row">
                <h2 className="col titleDemandImporter">{"Importador de Demanda"}</h2>
            </div>
            <div className="row">
                <div className="col col-8">
                    <div className={`navDemandImporter`}>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("#/demandImporter/importers") }} className={`nav-link pointer ${getCSSClass("importers")}`} data-cy="link-status"><span>Importaciones</span></a>
                        </div>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("#/demandImporter/templates") }} className={`nav-link pointer ${getCSSClass("templates")}`} data-cy="link-status"><span>Plantillas</span></a>
                        </div>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("#/demandImporter/masterItems") }} className={`nav-link pointer ${getCSSClass("masterItems")}`} data-cy="link-status"><span>Master Items</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default MenuDemandImporter;